.viewport {
	position: fixed;
	inset-block-end: 0;
	inset-inline-end: 0;
	z-index: var(--z-toast);
	display: flex;
	flex-direction: column;
	gap: var(--spacing-2);
	inline-size: min(92vw, 22rem);
	max-inline-size: 100vw;
	padding: var(--spacing-4);
	margin: 0;
	outline: none;
	list-style: none;
}

.toast {
	display: flex;
	gap: var(--spacing-3);
	align-items: flex-start;
	padding: var(--spacing-3) var(--spacing-4);
	background-color: var(--colour-background-raised);
	border: 1px solid var(--colour-border-subtle);
	border-inline-start: 3px solid var(--colour-text-secondary);
	border-radius: var(--radius-md);
	box-shadow: var(--shadow-md);
	animation: toast-in var(--motion-base) var(--ease-standard);

	&[data-variant='success'] {
		border-inline-start-color: var(--colour-success);
	}

	&[data-variant='error'] {
		border-inline-start-color: var(--colour-danger);
	}

	&[data-state='closed'] {
		animation: toast-out var(--motion-fast) var(--ease-standard);
	}

	&[data-swipe='move'] {
		transform: translateX(var(--radix-toast-swipe-move-x));
	}

	&[data-swipe='end'] {
		animation: toast-out var(--motion-fast) var(--ease-standard);
	}
}

.body {
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: var(--spacing-1);
	min-inline-size: 0;
}

.title {
	margin: 0;
	font-size: var(--font-size-sm);
	font-weight: var(--font-weight-medium);
	color: var(--colour-text-primary);
}

.description {
	margin: 0;
	font-size: var(--font-size-sm);
	color: var(--colour-text-secondary);
}

/* An inline action button (e.g. Undo), sitting before the close affordance. */
.action {
	flex-shrink: 0;
	align-self: center;
	padding: var(--spacing-1) var(--spacing-2);
	font-size: var(--font-size-xs);
	font-weight: var(--font-weight-semibold);
	color: var(--colour-brand-text);
	cursor: pointer;
	background: none;
	border: none;
	border-radius: var(--radius-sm);

	&:hover {
		background: var(--colour-background-muted);
	}
}

.close {
	display: inline-flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	inline-size: 1.25rem;
	block-size: 1.25rem;
	color: var(--colour-text-secondary);
	cursor: pointer;
	background: none;
	border: none;
	border-radius: var(--radius-sm);

	& > svg {
		inline-size: 0.875rem;
		block-size: 0.875rem;
	}

	&:hover {
		color: var(--colour-text-primary);
	}
}

@keyframes toast-in {
	from {
		opacity: 0;
		transform: translateX(calc(100% + var(--spacing-4)));
	}
}

@keyframes toast-out {
	to {
		opacity: 0;
		transform: translateX(calc(100% + var(--spacing-4)));
	}
}

@media (prefers-reduced-motion: reduce) {
	.toast {
		animation: none;
	}
}
